BuyButton = window.BuyButton ?= {}

BuyButton.View = Backbone.View.extend
  el: "#purchase-cluster"
  events:
    "click a.buy-button:not(.external-buy)": "buyButtonClicked"
    "click .view-options a" : "viewAllOptions"

  initialize: ({multiOptionEnabled}) ->
    @$buyContainer = @$(".buy")
    @$buyButton = @$("a.buy-button")
    @$giftButton = @$("a.buy-for-friend")
    @$dealHeroPrice = @$(".deal-hero-price")
    @$mainBtnPrice = @$("#main-button-formatted-price")
    @$priceBox = @$(".price")
    @$priceLabel = @$(".price-label")
    @$value = @$("#discount-value, .discount-value")
    @$smallPrice = @$('.price-small, .discount-value')
    @$finePrintDesc = $(".fine-print-description")

    @hasBeenClicked = false
    @variationsSelected = false
    @multiOptionEnabled = multiOptionEnabled

    processLink = =>
      @processLink()

    BuyButton.eventBus.board('buy_button_clicked', processLink)(1000)

    window.DealEventPipe.on "priceUpdate", (priceData) =>
      @variationsSelected = priceData.variationsSelected
      @$buyButton.removeClass("login-disabled")
      @updatePrice priceData
      @updateValue priceData
      @updateBuyButton priceData

  buyButtonClicked: (e) ->
    e.preventDefault()
    BuyButton.eventBus.go 'buy_button_clicked', e

  shouldShowPriceInTwoRows: ->
    includeMargin = true
    @$priceBox.outerWidth(includeMargin) + @$smallPrice.outerWidth(includeMargin) > @$dealHeroPrice.outerWidth(includeMargin)

  setPriceWithSale: (newPrice, regularPrice) ->
    @$priceBox.text newPrice
    @$priceBox.after "<span class='price-small'>#{regularPrice}</span>"
    @$smallPrice = @$dealHeroPrice.find('.price-small')
    @fixPossiblePriceOverflow()

  setOfferLabel: (offerLabel) ->
    return unless offerLabel

    offerLabel = "<span class='urgency-pricing-label'>#{offerLabel}</span>"

    @$dealHeroPrice.append offerLabel
    @$dealHeroPrice.addClass 'urgency-pricing'

  cleanPriceBox: ->
    @$priceBox.removeClass 'two-rows'
    @$dealHeroPrice.find('.price-small').remove()
    @$dealHeroPrice.removeClass 'urgency-pricing'
    @$dealHeroPrice.find('.urgency-pricing-label').remove()

  setPriceBox: (price, sale) ->
    @cleanPriceBox()
    if sale?.urgencyPricing?
      @setPriceWithSale sale.urgencyPricing.newPrice, sale.urgencyPricing.regularPrice
      @setOfferLabel sale.urgencyPricing.pricingMetadata?.offerLabel
    else if sale?.offer?
      @$mainBtnPrice.text sale.offer.formattedNewPrice
      @setPriceWithSale sale.offer.formattedOldPrice, sale.offer.formattedValue
    else
      @$priceBox.text price

  updatePrice: ({variationsSelected, price, sale, lengthClass}) ->
    @$buyContainer.removeClass @currentPriceClass if @currentPriceClass
    @$buyContainer.addClass lengthClass if lengthClass
    @setPriceBox price, sale
    @currentPriceClass = lengthClass
    if variationsSelected
      @$priceLabel.hide()
    else
      @$priceLabel.show()

  updateValue: ({value, hideOriginalPriceAndDiscount}) ->
    @$value.html if hideOriginalPriceAndDiscount then "" else value

  updateBuyButton: ({variationsSelected, buyUrl, sale}) ->
    if variationsSelected
      @$buyButton.attr("href", buyUrl)
      @$giftButton.attr("href", buyUrl)

  disableBuyButton: ->
    @hasBeenClicked = true
    @$buyButton.removeClass("state-buy")
    @$buyButton.addClass("state-disabled")
    @$buyButton.addClass('loading')

  enableBuyButton: ->
    @hasBeenClicked = false
    @$buyButton.removeClass("state-disabled")
    @$buyButton.addClass("state-buy")
    @$buyButton.removeClass('loading')

  processLink: ->
    unless @hasBeenClicked
      window.location = @$buyButton.attr("href")

    @disableBuyButton()

  updateClusterOptionPrice: ($option) ->
    formattedPrice = $option.attr('data-formatted-price') or ''
    formattedValue = if formattedPrice is $option.attr('data-formatted-value') then '' else $option.attr('data-formatted-value')
    offerLabel = $option.attr('data-offer-label') or ''
    soldMessage = $option.attr('data-sold-message') or ''
    breakoutOptionID = $option.attr('id')
    finePrintDesc = $option.attr('data-description') or ''

    @$priceBox.text(formattedPrice)
    @$smallPrice.text(formattedValue)
    @fixPossiblePriceOverflow()

    # optional elements may or may not exist
    @updateClusterOptionDiscount($option)
    $option.find('.urgency-pricing-label').text(offerLabel)
    @updateUrgencyPricingMetaData(offerLabel, breakoutOptionID)

    if soldMessage.length
      @$qtyBought.text(soldMessage)
      @$dealStatus.show()
    else
      @$dealStatus.hide()

    @updateFinePrint(finePrintDesc)

  updateClusterOptionDiscount: ($option) ->
    discountPercentage = $option.attr('data-discount-percentage') or ''
    savings = $option.attr('data-savings') or ''
    if discountPercentage
      @$discountPercent.text(discountPercentage)
      @$discountYouSave.text(savings)
      $('.deal-discount').show()
    else
      $('.deal-discount').hide()

  updateUrgencyPricingMetaData: (offerLabel, breakoutOptionID) ->
    if offerLabel
      @$dealHeroPrice.addClass('urgency-pricing')
      @$dealHeroPrice.attr('data-bhw', 'UrgencyPrice')
    else
      @$dealHeroPrice.removeClass('urgency-pricing')
      @$dealHeroPrice.removeAttr('data-bhw')

  fixPossiblePriceOverflow: ->
    @$priceBox.removeClass('two-rows')
    @$smallPrice.removeClass('two-rows')
    if @shouldShowPriceInTwoRows()
      @$priceBox.addClass('two-rows')
      @$smallPrice.addClass('two-rows')

  viewAllOptions: (e) ->
    e.preventDefault()
    BuyButton.eventBus.go 'view_options_clicked', e

  updateFinePrint: (finePrintDesc) ->
    return unless finePrintDesc?.length
    $body = $(document.body)

    if $body.hasClass('getaways') or $body.hasClass('getaways-booking')
      finePrintLines = if I18n?.country is "US"
        tempLines = _.filter finePrintDesc.split(". "), (line) ->
          line.replace(/<[^>]*>/g, '').trim().length > 0

        tempLines = _.map tempLines, (line) -> "<li class='fine-print-description'>#{line}</li>"
        tempLines.join ''

      else
        "<span class='fine-print-description'>#{finePrintDesc.replace(/\n/g, '<br/>')}</span>"

      $(finePrintLines).insertBefore(@$finePrintDesc.first())
      @$finePrintDesc.remove()
      @$finePrintDesc = $('.fine-print-description')

    else
      @$finePrintDesc.html finePrintDesc


module.exports = BuyButton.View
